import React, {useRef} from 'react';
import {Box, Grid} from "@mui/material";
import Link from "@mui/material/Link";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Button from "@mui/material/Button";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router";

const RecoveryPasswordStep3 = ({setSlideIndex}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef = useRef('');
    return (
        <Grid container sx={{justifyContent: 'center'}}>

            <Box sx={{
                my: 8,
                mx: 4,
                flexDirection: 'column',
                width: {xs:'null',md:'60%'}

            }}>


                <Grid sx={{textAlign: 'start'}}>
                    <Link onClick={() => setSlideIndex(1)}
                          underline="none" href="#"
                          variant="body2">
                        <KeyboardBackspaceIcon/>
                    </Link>
                </Grid>
                <Grid sx={{textAlign: 'center', mb: 2,fontSize:{xs:'12px',sm:'12px'}}}>
                    <Typography>
                        رمز عبور جدید خود را وارد کنید
                    </Typography>
                </Grid>


                <TextField sx={{marginBottom: '15px'}}

                           fullWidth
                           name="password"
                           label="رمز عبور"
                           type="password"
                           id="password"
                           autoComplete="current-password"
                />
                <TextField

                    fullWidth
                    name="password"
                    label="تکرار رمز عبور"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                />

                <Grid sx={{display: 'flex', flexDirection: 'column',mt:4,color:'#797979'}}>
                    <Grid sx={{display: 'flex', textAlign: 'end', alignItems: 'center', justifyContent: 'flex-end',gap:'6px'}}>
                        <Typography sx={{fontSize: {xs: '12px', sm: '12px', md: '15px'}}} variant={'h5'}>رمز عبور شما
                            حداقل ۸ کاراکتر باشد </Typography>
                        <ErrorOutlineIcon fontSize={"small"}/>
                    </Grid>

                    <Grid sx={{display: 'flex', alignItems: 'right', justifyContent: 'flex-end',mt:1,gap:'6px'}}>
                        <Typography sx={{fontSize: {xs: '12px', sm: '12px', md: '15px'},textAlign: 'end'}}>از حروف بزرگ و کوچک استفاده
                            شده باشد </Typography>
                        <ErrorOutlineIcon fontSize={"small"}/>
                    </Grid>
                </Grid>
                <Box>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{
                            my: 2,
                            padding: '12px',
                            borderRadius: '40px',
                            backgroundColor: '#592EA9',
                            ":hover": {bgcolor: '#5D5FEF'}
                        }}
                    >
                        وارد شو
                    </Button>
                </Box>

                <Grid sx={{
                    width: '100%',
                    display: {xs: 'grid', sm: 'grid', md: 'flex'},
                    justifyContent: {xs: 'end', sm: 'end', md: 'space-between'},
                    textAlign: {xs: 'end', sm: 'end'}
                }}>

                    <Link  onClick={() => navigate('/admin/signup')} sx={{color: '#797979'}} underline="always" href="#" variant="body2">
                        {"سـاخت حساب کاربری"}
                    </Link>

                    <Link underline="none" variant="body2">
                        حساب کاربری شادزی ندارید؟
                    </Link>



                </Grid>
            </Box>
        </Grid>

    )
        ;
};

export default RecoveryPasswordStep3;
